import axios from "axios";
import { ENDPOINTS } from "../jsx/services/ENDPOINT";

const BASE_URL = `${ENDPOINTS.BASE_2}/expense-categories`;

// Get all
export const getExpenseCategories = async () => {
  return await axios.get(BASE_URL);
};

// Create
export const createExpenseCategory = async (data) => {
  return await axios.post(BASE_URL, data);
};

// Update
export const updateExpenseCategory = async (id, data) => {
  return await axios.put(`${BASE_URL}/${id}`, data);
};

// Delete
export const deleteExpenseCategory = async (id) => {
  return await axios.delete(`${BASE_URL}/${id}`);
};
